export function filterRequiredOperators<T extends { value: string }>(operators: T[]) {
  return operators.filter((operator) => !['isEmpty', 'isNotEmpty'].includes(operator.value));
}
